import { render, staticRenderFns } from "./PageSecond.vue?vue&type=template&id=5f3b4111&scoped=true"
import script from "./PageSecond.vue?vue&type=script&lang=js"
export * from "./PageSecond.vue?vue&type=script&lang=js"
import style0 from "./PageSecond.vue?vue&type=style&index=0&id=5f3b4111&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3b4111",
  null
  
)

export default component.exports